<template>
	<div class="container">
		<div class="carousel-container" id="carousel-container" ref="carousel-container">
			<el-carousel class="carousel" :autoplay='autoplay' direction='vertical' indicator-position="none" ref="slideCarousel" @change="onCarouselChange">
				<el-carousel-item class="carousel-item" :style="{width:clientWidth+'px',height:clientHeight+'px'}" v-for="item in items" :key="item" 
				name='item'>
					<div class="page-item" v-if="item==0">
						<img class="page_bk" src="@/assets/home_bk.png"/>
						<div class="info_menu">
							<div class="home_title_label">Make socializing more enjoyable</div>
							<div class="home_title_label2">Linking Virtual and Reality</div>
							<div class="menu_section">
								<div class="menu_btn1">
									<img class="btn_icon1" src="@/assets/pingguo.png"/>
									<div class="btn_title">App Store</div>
								</div>
								<div class="menu_btn2">
									<img class="btn_icon2" src="@/assets/anzhuo.png"/>
									<div class="btn_title">Android</div>
								</div>
							</div>
						</div>
					</div>
					
					<div class="page-item" v-if="item==1">
						<img class="page_item1" src="@/assets/page_item1.png"/>
						<div class="text_menu1">
							<div class="title_label">Play</div>
							<div class="sub_title_label">Connect toys to unlock multiple </div>
							<div class="sub_title_label">gameplay options</div>
						</div>
					</div>
					
					<div class="page-item" v-if="item==2">
						<img class="page_item2" src="@/assets/page_item2.png"/>
						<div class="text_menu2">
							<div class="title_label">Real Online Users</div>
							<div class="sub_title_label">Multiple online users</div>
							<div class="sub_title_label">Quick response</div>
						</div>
					</div>
					
					<div class="page-item" v-if="item==3">
						<img class="page_item3" src="@/assets/page_item3.png"/>
						<div class="text_menu3">
							<div class="title_label">Private Chat</div>
							<div class="sub_title_label">Recommend interesting people to you</div>
							<div class="sub_title_label">based on interests and location</div>
						</div>
					</div>
					
					<div class="page-item" v-if="item==4">
						<img class="page_item4" src="@/assets/page_item4.png"/>
						<div class="text_menu4">
							<div class="title_label">Brilliant Dynamic</div>
							<div class="sub_title_label">Sharing a wonderful</div>
							<div class="sub_title_label">Discover interesting</div>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
		
		<div class="indexes_picker">
			<div class="indexes_line" @click="onClick(index)" v-bind:class='{itemSel:selectedIndex==index}' v-for="(item,index) in items">
				
			</div>
		</div>
			
	</div>
	
	
</template>

<script>
	
	import Vue from 'vue'

	export default{
		components: {
		},
		
		props:{
		},
		
		data(){
			return {
				items:["0","1","2","3","4"],
				clientWidth:0,
				clientHeight:0,
				selectedIndex:0,
				autoplay:false
			}
		},
			
		mounted() {
			var clientWidth = document.documentElement.clientWidth;//获取浏览器可视区域高度
			var clientHeight = document.documentElement.clientHeight;
			this.$data.clientWidth = clientWidth;
			this.$data.clientHeight = clientHeight;
			
			console.log("clientWidth:"+clientWidth);
			console.log("clientHeight:"+clientHeight);
			
			this.slideBanner();
		},
		
		methods:{
			// 滑动切换
			slideBanner() {
			  //选中的轮播图
			  var box = document.querySelector('#carousel-container');
			  var startPoint = 0;
			  var stopPoint = 0;
			  //重置坐标
			  var resetPoint = function () {
				startPoint = 0;
				stopPoint = 0;
			  }
			  //手指按下
			  box.addEventListener("touchstart", function (e) {
				//手指点击位置的X坐标
				startPoint = e.changedTouches[0].pageY;
			  });
			  //手指滑动
			  box.addEventListener("touchmove", function (e) {
				//手指滑动后终点位置X的坐标
				stopPoint = e.changedTouches[0].pageY;
			  });
			  //当手指抬起的时候，判断图片滚动离左右的距离
			  let that = this
			  box.addEventListener("touchend", function (e) {
				console.log("1：" + startPoint);
				console.log("2：" + stopPoint);
				if (stopPoint == 0 || startPoint - stopPoint == 0) {
				  resetPoint();
				  return;
				}
				if (startPoint - stopPoint > 0) {
				  resetPoint();
				  that.$refs.slideCarousel.next();
				  return;
				}
				if (startPoint - stopPoint < 0) {
				  resetPoint();
				  that.$refs.slideCarousel.prev();
				  return;
				}
			  });
			},
			
			onCarouselChange(res){
				console.log(res);
				var selectedIndex = res;
				this.$data.selectedIndex = selectedIndex;
				
				this.$emit('carouselChange',selectedIndex);
			},
			
			onClick(res){
				console.log(res);
				var selectedIndex = res;
				this.$refs.slideCarousel.setActiveItem(selectedIndex+"");
			},
		

		}
	}
	
	
	
</script>

<style scoped>
	.container{
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.carousel-container{
		width: 100%;
		height: 100%;
		background-color: white;
		z-index: 1000;
	}
	
	.carousel{
		background-color: white;
		width: 100%;
		height: 100%;
	}
	
	.page-item{
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.page_bk{
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}
	
	.info_menu{
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.menu_section{
		width: 100%;
		display: flex;
		margin-top: 20px;
		height: 60px;
		justify-content: center;
		align-items: center;
	}
	
	.menu_btn1{
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
		border: solid white 1px;
		height: 40px;
	}
	
	.menu_btn2{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 50px;
		border-radius: 4px;
		border: solid white 1px;
		height: 40px;
	}
	
	.btn_icon1{
		width: 16px;
		height: 20px;
		margin-left: 10px;
	}
	
	.btn_icon2{
		width: 19px;
		height: 20px;
		margin-left: 10px;
	}
	
	.btn_title{
		font-size: 24px;
		color: white;
		margin-left: 5px;
		margin-right: 10px;
	}
	
	
	.home_title_label{
		font-size: 75px;
		color: white;
		margin-top: 5px;
	}
	
	.home_title_label2{
		font-size: 40px;
		color: white;
		margin-top: 5px;
		text-align: right;
	}
	
	.page_item1{
		position: absolute;
		left: 30px;
		top: 80px;
		width: 801px;
		height: 453px;
	}
	
	.page_item2{
		position: absolute;
		left: 30px;
		top: 80px;
		width: 585px;
		height: 490px;
	}
	
	.page_item3{
		position: absolute;
		left: 30px;
		top: 80px;
		width: 585px;
		height: 467px;
	}
	
	.page_item4{
		position: absolute;
		left: 30px;
		top: 80px;
		width: 579px;
		height: 460px;
	}
	
	
	.text_menu1{
		position: absolute;
		left: 820px;
		top: 60px;
		bottom: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.text_menu2{
		position: absolute;
		left: 604px;
		top: 60px;
		bottom: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.text_menu3{
		position: absolute;
		left: 599px;
		top: 60px;
		bottom: 0;
		right: 50px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.text_menu4{
		position: absolute;
		left: 575px;
		top: 60px;
		bottom: 0;
		right: 50px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.text_menu5{
		position: absolute;
		left: 626px;
		top: 60px;
		bottom: 0;
		right: 50px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.title_label{
		font-size: 100px;
		color: #4A4A4A;
		font-weight: "bold";
		margin-bottom: 10px;
	}
	
	.sub_title_label{
		font-size: 30px;
		color: #4A4A4A;
		margin-top: 5px;
	}
	
	.sub_title_label2{
		font-size: 30px;
		color: #4A4A4A;
		margin-top: 5px;
		text-align: right;
	}
	
	.indexes_picker{
		position: fixed;
		right: 10px;
		width: 60px;
		top: 60px;
		bottom: 60px;
		z-index: 3000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.indexes_line{
		margin-top: 8px;
		border-radius: 4px;
		width: 8px;
		height: 20px;
		background-color: #D8D8D8;
	}
	
	.itemSel{
		background-color: #ED47FF;
	}

</style>